/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalVote
 */
export interface ProposalVote {
    /**
     * The staking address casting this vote.
     * @type {string}
     * @memberof ProposalVote
     */
    address: string;
    /**
     * The vote cast.
     * @type {string}
     * @memberof ProposalVote
     */
    vote: string;
    /**
     * The block height at which this vote was recorded.
     * @type {number}
     * @memberof ProposalVote
     */
    height?: number;
    /**
     * The second-granular consensus time of the block in which this vote was cast.
     * @type {Date}
     * @memberof ProposalVote
     */
    timestamp?: Date;
}

export function ProposalVoteFromJSON(json: any): ProposalVote {
    return ProposalVoteFromJSONTyped(json, false);
}

export function ProposalVoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalVote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'vote': json['vote'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'timestamp': !exists(json, 'timestamp') ? undefined : (new Date(json['timestamp'])),
    };
}

export function ProposalVoteToJSON(value?: ProposalVote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'vote': value.vote,
        'height': value.height,
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp.toISOString()),
    };
}


